import React, { Component } from 'react';
import moment from 'moment';
import { Table } from 'reactstrap';

class TableFamily extends Component {

    render() {
        return (
            <div className="row table-family">
                {!this.props.loading && (
                    <div className="col-12">
                        {this.props.listaFamilia && this.props.listaFamilia.length > 0 ? (
                            [<div key={1} className="row">
                                <div className="col-12 text-center">
                                    <h6>Lista de familiares</h6>
                                </div>
                            </div>,
                            <Table key={2} bordered>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nome</th>
                                        <th>Código de membro</th>
                                        <th>Situação</th>
                                        <th>Divisão</th>
                                        <th>Dt. Nascimento</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.listaFamilia.map((fam, index) => {
                                        return (
                                            <tr key={index}>
                                                <th scope="row">{index + 1}</th>
                                                <td>
                                                    <a href={`/assinante/${fam.idUsuario}`}>{fam.nome}</a>
                                                </td>
                                                <td>{fam.codMembro}</td>
                                                <td>{fam.situacao}</td>
                                                <td>{fam.divisao}</td>
                                                <td>{moment.utc(fam.dtNascimento).format("DD/MM/YYYY")}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>]
                        ) : (
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <p>Nenhum familiar cadastrado.</p>
                                    </div>
                                </div>
                            )}
                    </div>

                )}

            </div>
        )
    }
}

export default TableFamily;